import React, { useCallback, useEffect } from 'react';
import PaymentMethod from './components/PaymentMethod';
import CheckoutLayout from '../CheckoutLayout';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCheckout, useSalesFunnel } from '~/stores';
import useAppNavigation from '~/hooks/useAppNavigation';
import { Text } from '~/components';
import { CheckoutStepNames } from '~/utils/salesFunnel';

const PAGE = 1;

const schema = yup
  .object()
  .shape({
    paymentMethodCode: yup.string().required(),
  })
  .required();

interface PaymentMethodsStep {
  paymentMethodCode: string;
}

const PaymentMethods: React.FC = () => {
  const { push } = useAppNavigation();
  const { setPaymentMethod, setPage, insurance } = useCheckout();
  const { newStepLog } = useSalesFunnel();

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<PaymentMethodsStep>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const onSubmit = useCallback(
    ({ paymentMethodCode }: PaymentMethodsStep) => {
      const selectedPaymentMethod = insurance?.paymentMethods?.find(
        (currentPaymentMethod) =>
          String(currentPaymentMethod.code) === String(paymentMethodCode)
      );

      if (selectedPaymentMethod) {
        setPaymentMethod(selectedPaymentMethod);
      } else if (insurance?.paymentMethods[0]) {
        setPaymentMethod(insurance?.paymentMethods[0]);
      }

      setPage(PAGE);
      push('MarisaServicos_Checkout', { step: PAGE });
    },
    [insurance?.paymentMethods, push, setPage, setPaymentMethod]
  );

  useEffect(() => {
    newStepLog(CheckoutStepNames.PAYMENT_METHODS);
  }, [newStepLog]);

  if (!insurance?.paymentMethods) return null;

  return (
    <CheckoutLayout isValid={isValid} onSubmit={handleSubmit(onSubmit)}>
      <Text className="text-xl text-gray-600 mb-9">
        Qual a forma de pagamento?
      </Text>

      <Controller
        control={control}
        name="paymentMethodCode"
        render={({ field: { value, onChange } }) => (
          <>
            {insurance?.paymentMethods.map((paymentMethod) => {
              return (
                <PaymentMethod
                  key={paymentMethod.code}
                  data={paymentMethod}
                  onPress={onChange}
                  value={value}
                />
              );
            })}
          </>
        )}
      />
    </CheckoutLayout>
  );
};

export default PaymentMethods;
